// Google Consent Mode v2 helpers.
// Consent state is stored in localStorage; banner triggers gtag('consent','update', ...) and
// pushes 'cookie_consent_update' onto dataLayer.

export const CONSENT_STORAGE_KEY = "zyravex_consent_v1";

export const DEFAULT_CONSENT = {
  necessary: true, // always on
  analytics: false,
  ads: false,
  personalization: false,
  timestamp: null,
};

function hasGtag() {
  return typeof window !== "undefined" && typeof window.gtag === "function";
}

function ensureDataLayer() {
  if (typeof window === "undefined") return null;
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
}

export function readConsent() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return { ...DEFAULT_CONSENT, ...parsed };
  } catch (_) {
    return null;
  }
}

export function writeConsent(consent) {
  if (typeof window === "undefined") return;
  const withTs = { ...consent, timestamp: new Date().toISOString() };
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(withTs));
  } catch (_) {
    // ignore
  }
}

// Push the consent state to gtag + dataLayer.
export function applyConsent(consent) {
  const payload = {
    ad_storage: consent.ads ? "granted" : "denied",
    ad_user_data: consent.ads ? "granted" : "denied",
    ad_personalization: consent.ads ? "granted" : "denied",
    analytics_storage: consent.analytics ? "granted" : "denied",
    functionality_storage: "granted",
    personalization_storage: consent.personalization ? "granted" : "denied",
    security_storage: "granted",
  };

  if (hasGtag()) {
    window.gtag("consent", "update", payload);
  }
  const dl = ensureDataLayer();
  if (dl) {
    dl.push({ event: "cookie_consent_update", consent: payload });
  }
}

// Convenience helper used by the banner buttons.
export function updateConsent(consent) {
  writeConsent(consent);
  applyConsent(consent);
}

export const CONSENT_ACCEPT_ALL = {
  necessary: true,
  analytics: true,
  ads: true,
  personalization: true,
};

export const CONSENT_REJECT_ALL = {
  necessary: true,
  analytics: false,
  ads: false,
  personalization: false,
};
